import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { CardHeader } from "@tql/ui-components-react/kendo/layout";
import { Button } from "@tql/ui-components-react/tql/buttons";
import { copy_04, globe_06 } from "@tql/ui-components-react/untitled/icons";

export const TrackingHistoryHeader = ({
	onCopyLink,
	carrierWebsite,
	isSaving,
}: {
	onCopyLink: () => void;
	carrierWebsite?: string | null;
	isSaving: boolean;
}) => {
	const trimmedWebsite = carrierWebsite?.trim();
	// Carrier websites returned by the API may omit the protocol; without one the
	// browser would treat the value as a relative path, so default to https.
	let carrierWebsiteUrl: string | null = null;
	if (trimmedWebsite) {
		carrierWebsiteUrl = /^https?:\/\//i.test(trimmedWebsite)
			? trimmedWebsite
			: `https://${trimmedWebsite}`;
	}

	return (
		<CardHeader className={"tracking-history-header"}>
			<h3>Tracking History</h3>
			<div className={"tracking-history-actions"}>
				<Button
					disabled={isSaving}
					onClick={onCopyLink}
					startIcon={<SvgIcon icon={copy_04} />}
					variant={"tertiary"}
				>
					Tracking Link
				</Button>
				<Button
					aria-label={"Open carrier website"}
					disabled={isSaving || !carrierWebsiteUrl}
					onClick={() =>
						carrierWebsiteUrl &&
						window.open(carrierWebsiteUrl, "_blank", "noopener,noreferrer")
					}
					variant={"tertiary"}
				>
					<SvgIcon className={"carrier-website-icon"} icon={globe_06} />
				</Button>
			</div>
		</CardHeader>
	);
};
